export { default } from './MoreButtonCDS';
